export const VALIDATION_STATE = ['none', 'error'];
export const DROPDOWN_LABEL_POSITION = ['default', 'left', 'above'];
export const registeredDropdowns = [];
/**
 * Closes all dropdowns if the document is clicked.
 */
export const onDocumentClick = () => {
    closeAllDropdowns();
};
/**
 * Closes all dropdowns if the Escape key is pressed.
 *
 * @param e
 */
export const onDocumentKeydown = (e) => {
    if (e.key === 'Escape') {
        closeAllDropdowns();
    }
};
/**
 * Adds event listeners to the document if they don't already exist.
 *
 * @param dropdown
 */
export const addDocumentEventListeners = (dropdown) => {
    if (registeredDropdowns.length === 0) {
        document.addEventListener('click', onDocumentClick);
        document.addEventListener('keydown', onDocumentKeydown);
    }
    if (!registeredDropdowns.includes(dropdown)) {
        registeredDropdowns.push(dropdown);
    }
};
/**
 * Removes event listeners from the document.
 *
 * @param dropdown
 */
export const removeDocumentEventListeners = (dropdown) => {
    const index = registeredDropdowns.indexOf(dropdown);
    if (index > -1) {
        registeredDropdowns.splice(index, 1);
    }
    if (registeredDropdowns.length === 0) {
        document.removeEventListener('click', onDocumentClick);
        document.removeEventListener('keydown', onDocumentKeydown);
    }
};
/**
 * Closes all dropdowns.
 */
export const closeAllDropdowns = () => {
    for (const dropdown of registeredDropdowns) {
        closeDropdown(dropdown);
    }
};
/**
 * Closes all dropdowns except the given one.
 *
 * @param except
 */
export const closeOtherDropdowns = (except) => {
    for (const dropdown of registeredDropdowns) {
        if (dropdown !== except) {
            closeDropdown(dropdown);
        }
    }
};
/**
 * Closes a dropdown.
 *
 * @param dropdown
 */
export const closeDropdown = (dropdown) => {
    dropdown.open = false;
    Array.from(dropdown.listEl.children).forEach(optionEl => {
        optionEl.classList.remove('active');
    });
};
//# sourceMappingURL=dropdown-wrapper-utils.js.map
